import { render, staticRenderFns } from "./Bando33Fase2.vue?vue&type=template&id=008394b6&scoped=true"
import script from "./Bando33Fase2.vue?vue&type=script&lang=js"
export * from "./Bando33Fase2.vue?vue&type=script&lang=js"
import style0 from "./Bando33Fase2.vue?vue&type=style&index=0&id=008394b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008394b6",
  null
  
)

export default component.exports